import React, { useState } from "react";
import { getImageUrl } from "../api/axios";
import { useSettings } from "../context/SettingsContext";

const TOURS_PER_PAGE = 10;

export default function TourList({ tours, startEditing, remove }) {
  const { settings } = useSettings();
  const cs = settings.currency_symbol || '$';
  const discount = Number(settings.discount_percentage) || 0;
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(tours.length / TOURS_PER_PAGE);
  const paginatedTours = tours.slice((page - 1) * TOURS_PER_PAGE, page * TOURS_PER_PAGE);

  return (
    <>
      <ul className="divide-y divide-slate-200 rounded-md border border-slate-200 dark:divide-slate-800 dark:border-slate-800">
        {paginatedTours.map((t) => (
          <li
            key={t.id}
            className="flex items-center justify-between p-3 text-sm"
          >
            <div className="flex items-center gap-3">
              <img
                src={getImageUrl(t.thumbnail)}
                alt={t.title}
                className="h-10 w-14 rounded-md object-cover bg-slate-100 dark:bg-slate-800 flex-shrink-0"
                onError={(e) => { e.target.src = "/emogiesnack.png"; }}
              />
              <div className="min-w-0">
                <span className="font-medium block truncate">{t.title}</span>
                <div className="flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                  {discount > 0 ? (
                    <span className="flex items-center gap-1">
                      <span className="line-through text-slate-400">{cs}{t.price}</span>
                      <span className="text-emerald-600 dark:text-emerald-400 font-semibold">{cs}{(t.price * (1 - discount / 100)).toFixed(2)}</span>
                    </span>
                  ) : (
                    <span>{cs}{t.price}</span>
                  )}
                  {t.duration_days && <span>· {t.duration_days}d</span>}
                  {t.city && <span>· {t.city}</span>}
                </div>
              </div>
            </div>
            <div className="flex gap-2 flex-shrink-0">
              <button
                onClick={() => startEditing(t)}
                className="rounded-md bg-blue-600 px-2 py-1 text-xs text-white hover:bg-blue-700"
              >
                Update
              </button>
              <button
                onClick={() => remove(t.id)}
                className="rounded-md bg-red-600 px-2 py-1 text-xs text-white hover:bg-red-700"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>

      {tours.length > TOURS_PER_PAGE && (
        <div className="flex items-center justify-center gap-2 mt-6">
          <button
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium transition-colors hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-slate-700 dark:hover:bg-slate-800"
          >
            Previous
          </button>
          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => setPage(i + 1)}
              className={`rounded-lg px-3 py-2 text-sm font-medium transition-colors ${
                page === i + 1
                  ? "bg-emerald-600 text-white"
                  : "border border-slate-300 hover:bg-slate-100 dark:border-slate-700 dark:hover:bg-slate-800"
              }`}
            >
              {i + 1}
            </button>
          ))}
          <button
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
            className="rounded-lg border border-slate-300 px-3 py-2 text-sm font-medium transition-colors hover:bg-slate-100 disabled:opacity-40 disabled:cursor-not-allowed dark:border-slate-700 dark:hover:bg-slate-800"
          >
            Next
          </button>
        </div>
      )}
    </>
  );
}
